import React, { memo, useEffect } from 'react';
import { useDocument } from '../hooks/useDocument.js';
import { focusFirstFocusableNode } from '../utils/focus.js';
export const Focus = memo(({ children, disabled, root }) => {
    const { document } = useDocument();
    useEffect(() => {
        if (disabled || !root) {
            return;
        }
        const node = isRef(root) ? root.current : root;
        if (!node || node.querySelector('[autofocus]')) {
            return;
        }
        focusFirstFocusableNode(document, node, false);
    }, [document, disabled, root]);
    return React.createElement(React.Fragment, null, children);
});
function isRef(ref) {
    return ref.current !== undefined;
}
//# sourceMappingURL=Focus.js.map